import Service from "../Service";
const resource = "HmnMarking/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    duplicate(obj, requestID) {
        return Service.post(resource + "duplicate", obj, {
            params: { requestID: requestID },
        });
    },
    // list(parameters,requestID) {
    //     return Service.post(resource + "list", parameters, {
    //         params: { requestID: requestID },
    //     });
    // },
    verificationMarking(obj, requestID) {
        return Service.post(resource + "verificationMarking", obj, {
            params: { requestID: requestID },
        });
    },
    calculateStatus(obj, requestID) {
        return Service.post(resource + "calculateStatus", obj, {
            params: { requestID: requestID },
        });
    },

    getMarkingByWorkerAndDate(WkrID, dateIni, dateEnd, requestID) {
        return Service.post(resource + "getMarkingByWorkerAndDate",{}, {
            params: {
                WkrID: WkrID,
                StarTime: dateIni,
                EndDate: dateEnd,
                requestID: requestID,
            },
        });
    },
    insert(obj, requestID) {
        return Service.post(resource + "insert", obj, {
            params: { requestID: requestID },
        });
    },
};